<template>
  <slot></slot>
</template>

<script setup>
import { useEventListener, useResizeObserver } from "@vueuse/core";
import { onMounted, ref } from "vue";
import { useHostElement } from "#ce/composables/useHostElement";

const ACTIVE_STICKY_COLUMN_CLASS = "--active-sticky-column";
const SELECTED_ROW_CLASS = "--selected";
const MENU_STATE_EVENT = "change-menu-appearance-state";
const TABLE_SELECTOR = "table.sticky-table-columns";

// The element sits beside the table it marks. A table slotted into a shadow root resolves
// `width: 100%` against its own max-content instead of the scroll container.

const host = useHostElement();
const container = ref(null);
const table = ref(null);

function markOverflow([entry]) {
  const overflows = container.value.getBoundingClientRect().width < entry.contentRect.width;
  entry.target.classList.toggle(ACTIVE_STICKY_COLUMN_CLASS, overflows);
}

function markSelectedRow({ detail, target }) {
  target.closest("tr")?.classList.toggle(SELECTED_ROW_CLASS, Boolean(detail?.show));
}

onMounted(() => {
  container.value = host?.parentElement ?? null;
  table.value = container.value?.querySelector(TABLE_SELECTOR) ?? null;
});

useResizeObserver(table, markOverflow);
useEventListener(container, MENU_STATE_EVENT, markSelectedRow);
</script>

<style>
:host {
  display: none;
}
</style>
